import {Box, Button, styled, Typography} from "@mui/material";
import {color} from "../../../theme/includes/color";

export const BoardCardContainer = styled(Box)<{ active?: boolean }>(({ active }) =>({
  minWidth: '200px',
  maxHeight: '154px',
  minHeight: '154px',

  width: '100%',

  height: '100%',

  padding: active ? '8px' : '16px',

  backgroundColor: color('white-100'),
  borderRadius: '16px',

  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',

  cursor: 'pointer',
}))

export const BoardCardIconContainer = styled(Box)({
  position: 'relative',
})

export const BoardCardStatus = styled(Box)({
  position: 'absolute',
  top: '20px',
  left: '20px',
})

export const BoardCardTitle = styled(Typography)({
})

export const BoardCardSubTitle = styled(Typography)({
  color: color('grey-100'),
})

export const BoardCardButtonWrapper = styled(Box)({
  height: '100%',
  padding: '12px 8px',
  backgroundColor: color('grey-300'),
  borderRadius: '8px',
  display: "flex",
  flexDirection: 'column',
  alignItems: 'start',
  justifyContent: 'end',
})

export const BoardCardsActive = styled(Box)({
  maxWidth: '260px',
  flexGrow: 1,
  flexBasis: '230px',
})

export const BoardCardButton = styled(Button)({
  color: color('black-100'),
  '&:hover': {
    color: color('blue-100'),
    backgroundColor: color('white-100'),
    borderRadius: '12px',
    'svg': {
      'path': {
        stroke: color('blue-100'),
      }
    }
  }
})

export const BoardCardsDeleteMod = styled(Box)({
  maxWidth: '260px',
  minWidth: '200px',
  maxHeight: '154px',
  minHeight: '154px',

  height: '100%',
  padding: '8px',

  backgroundColor: color('white-100'),
  borderRadius: '16px',

  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',

  cursor: 'pointer',
})

export const BoardCardsDeleteModContent = styled(Box)({
  height: '100%',
  padding: '8px',
  backgroundColor: color('grey-300'),
  borderRadius: '8px',
  display: "flex",
  flexDirection: 'column',
  alignItems: 'start',
  justifyContent: 'space-between',
})

export const BoardCardsDeleteModButtons = styled(Box)({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  gap: '6px',
  marginTop: '45px',
  'button': {
    width: '100%',
    backgroundColor: color('white-100'),
    color: color('black-100'),
    borderRadius: '12px',
    '&:last-child': {
      color: color('red-100'),
    }
  }
})

